var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"loadingbg",attrs:{"element-loading-text":"同步数据中...","element-loading-background":"rgba(255, 255, 255, 0)"}},[_c('img',{attrs:{"src":require("../../public/lg.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }